"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * XRP Ledger networks that components can be attached to.
 */
var XrplNetwork;
(function (XrplNetwork) {
    XrplNetwork["Dev"] = "devnet";
    XrplNetwork["Test"] = "testnet";
    XrplNetwork["Main"] = "mainnet";
})(XrplNetwork || (XrplNetwork = {}));
exports.default = XrplNetwork;
//# sourceMappingURL=xrpl-network.js.map